import Config from "../../../config/app.config.json";
import { useEffect, useState } from "react";
import { useAppDispatch, useAppSelector } from "../../../app/hooks";
import { meetTeamContent } from "../../../features/strapi/aboutUsSlice";
import { useNonInitialEffect } from "../../../utils/commonFunctions/UseNonInitialEffectHook";
import { isTemplateExisits } from "../../../utils/commonFunctions/mapTemplatesToPage";
import { addMultipleCacheData } from "../../../utils/commonFunctions/addMultipleCacheData";
import { getCache } from "../../../utils/commonFunctions/getCacheFunction";

const TeamIntroComponent = isTemplateExisits(Config.AboutUs.TeamIntro)
  ? require(`./${Config.AboutUs.TeamIntro.template}_TeamIntro`).default
  : null;

export type teamIntroProps = {
  meetTeamState?: any;
};
export const TeamIntro = () => {
  const [content, setContent] = useState<any>(null);
  const [cacheTeamIntro, setCacheTeamIntro] = useState<any>(null);
  const { teamIntroContent } = useAppSelector(
    (state: any) => state.strapi.aboutUs
  );
  const dispatch = useAppDispatch();
  useEffect(() => {
    getCache("TeamIntroAboutUs", meetTeamContent, setCacheTeamIntro, dispatch);
  }, []);
  useNonInitialEffect(() => {
    setContent(teamIntroContent);
    addMultipleCacheData("TeamIntroAboutUs", teamIntroContent);
  }, [teamIntroContent]);
  return (content || cacheTeamIntro) ? (
    <TeamIntroComponent
      meetTeamState={cacheTeamIntro ? cacheTeamIntro : content}
    />
  ) : null;
};
